export default "__VITE_ASSET__24e43780__"